import { Link } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { ArrowRight, Leaf, Heart, Clock, Star } from "lucide-react";
import { useTranslation } from "react-i18next";

const Index = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-gray-50">
            <Navigation />

            {/* Hero Section */}
            <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary/10 to-secondary/10">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center">
                        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6">{t("index.hero.title")}</h1>
                        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">{t("index.hero.subtitle")}</p>
                        <Link
                            to="/build-diet"
                            className="inline-flex items-center bg-primary text-white px-6 py-3 rounded-md hover:bg-primary/90 transition-colors text-lg font-medium"
                        >
                            {t("index.hero.cta")} <ArrowRight className="ml-2" />
                        </Link>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="py-16 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                                <Leaf className="text-primary" size={24} />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("index.features.choose.title")}</h3>
                            <p className="text-gray-600">{t("index.features.choose.description")}</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                                <Heart className="text-primary" size={24} />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("index.features.track.title")}</h3>
                            <p className="text-gray-600">{t("index.features.track.description")}</p>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                                <Clock className="text-primary" size={24} />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("index.features.progress.title")}</h3>
                            <p className="text-gray-600">{t("index.features.progress.description")}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Call to Action Section */}
            <div className="py-16 px-4 sm:px-6 lg:px-8 bg-primary/80 text-white">
                <div className="max-w-7xl mx-auto text-center">
                    <h2 className="text-3xl sm:text-4xl font-bold mb-4">{t("index.cta.title")}</h2>
                    <p className="text-lg mb-6">{t("index.cta.subtitle")}</p>
                    <Link
                        to="/build-diet"
                        className="inline-flex items-center bg-white text-primary px-6 py-3 rounded-md hover:bg-white/90 transition-colors text-lg font-medium"
                    >
                        {t("index.cta.button")} <ArrowRight className="ml-2" />
                    </Link>
                </div>
            </div>

            {/* Testimonials Section */}
            <div className="py-16 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">{t("index.testimonials.title")}</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <Star className="text-yellow-500 mb-4" size={24} />
                            <p className="text-gray-600 italic">{t("index.testimonials.user1")}</p>
                            <h4 className="text-lg font-semibold mt-4">- Marco R.</h4>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <Star className="text-yellow-500 mb-4" size={24} />
                            <p className="text-gray-600 italic">{t("index.testimonials.user2")}</p>
                            <h4 className="text-lg font-semibold mt-4">- Elena G.</h4>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                            <Star className="text-yellow-500 mb-4" size={24} />
                            <p className="text-gray-600 italic">{t("index.testimonials.user3")}</p>
                            <h4 className="text-lg font-semibold mt-4">- Sara B.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
